import React from 'react';

import styles from './api-error.css';

export default ({ children, modifier, ...rest }) =>
    (<div className={`${styles.wrapper} ${modifier || ''}`} {...rest}>
        {children}
    </div>);

